import { ApolloError } from 'apollo-client';
import type { GraphQLError } from 'graphql';

const errorWhitelist = ['EXPERIENCE_UNAVAILABLE', 'FIELD_UNAVAILABLE', 'ISSUE_UNAVAILABLE'];

export const shouldHandleTheError = (error?: ApolloError): boolean => {
	if (error?.networkError) {
		return true;
	}

	// when issue links are disabled at the instance level and we request it, it throws an error but we still get the whole response
	// There is a issue links perm check that happens after loading the list so the UI already deals with this properly and we can ignore it
	// similarly, even when issue links are enabled, but the field itself is hidden in every screen it will throw an error but we'll still get the whole response
	const filterIssueLinksDisabledErrors = (graphQLError?: GraphQLError) => {
		const isWhitelisted = errorWhitelist.includes(graphQLError?.extensions?.errorType);
		return !isWhitelisted;
	};
	const errorsToShow = (error?.graphQLErrors || []).filter(filterIssueLinksDisabledErrors);

	return errorsToShow.length > 0;
};

export const getGraphqlErrorAttributes = (
	error?: Error | ApolloError,
): {} | { statusCodes: string; errorTypes: string } => {
	const isApolloError = error instanceof ApolloError;

	if (!isApolloError) {
		return {};
	}

	const getErrorAttribute = (
		graphQLErrors: readonly GraphQLError[],
		errorAttribute: 'statusCode' | 'errorType',
	): string => {
		const errors = graphQLErrors
			.map((graphQLError: GraphQLError) => graphQLError?.extensions?.[errorAttribute])
			.filter(Boolean);

		return JSON.stringify(errors);
	};

	return {
		statusCodes: getErrorAttribute(error?.graphQLErrors || [], 'statusCode'),
		errorTypes: getErrorAttribute(error?.graphQLErrors || [], 'errorType'),
	};
};
